import $ from "jquery";
import "Bacon";
import c from "common";

var getUniqueCheckboxId = (function (cache) {
  return function () {
    return "custom-select-checkbox-" + cache.id++; // eslint-disable-line no-plusplus
  };
})({
  id: 0
});

var states = {
  UNCHECKED: 0,
  CHECKED: 1,
  INDETERMINATE: 2
};

function createDom($select, options) {
  var $customDropdown = $('<div></div>').addClass('custom-dropdown');
  var $customDropdownSelect = $('<div></div>').addClass('custom-dropdown-select').appendTo($customDropdown);
  var $customDropdownSelectWrapper = $('<div></div>').addClass('custom-dropdown-select-wrapper').appendTo($customDropdownSelect);

  if (options.class) {
    $customDropdown.addClass(options.class);
  }

  if (options.checkboxState) {
    $customDropdown.addClass("with-checkbox");
    var checkboxId = getUniqueCheckboxId();
    $('<input type="checkbox" />').attr('id', checkboxId).addClass('custom-dropdown-checkbox styled-checkbox').appendTo($customDropdownSelectWrapper);
    $('<label />').attr('for', checkboxId).appendTo($customDropdownSelectWrapper);
  } else {
    $('<span></span>').addClass('customDropdownSelect').text($select.find('option:first').text()).show().appendTo($customDropdownSelectWrapper);
  }

  $select.clone().hide().appendTo($customDropdownSelectWrapper);

  var $customDropdownOptions = $('<div></div>').addClass('custom-dropdown-options').appendTo($customDropdown);
  var $customDropdownOptionsList = $('<ul></ul>').appendTo($customDropdownOptions);

  $select.find('option').each(function (i) {
    if (i === 0 && options.type === 'action') {
      return;
    }
    var $option = $(this);
    var $li = $('<li/>').addClass('select-item').addClass($option.get(0).className).attr('data-value', $option.attr('value')).text($option.text());
    $li.appendTo($customDropdownOptionsList);
  });

  $select.replaceWith($customDropdown);
  return $customDropdown;
}

function getValue($item) {
  return $item.attr('data-value');
}

function getCheckboxState(event, defaultSelect) {
  return $(event.target).is(":checked") ? defaultSelect : "none";
}

function closeDropdown() {
  $('.custom-dropdown').removeClass('open');
}

function eventTargetIsNotCheckbox(event) {
  return ["LABEL", "INPUT"].indexOf(event.target.tagName) === -1;
}

$(document.body).asEventStream('click', '.custom-dropdown-select-wrapper').filter(eventTargetIsNotCheckbox).onValue(function (event) {
  var $dropdown = $(event.target).parents('.custom-dropdown');
  $('.custom-dropdown').each(function () {
    if (this !== $dropdown[0]) {
      $(this).removeClass('open');
    }
  });
  $dropdown.toggleClass('open');
});

$(document.documentElement).asEventStream('click').map(c.$target).filter(function ($target) {
  return $target.closest('.custom-dropdown').length === 0;
}).onValue(closeDropdown);

function initSelect($select, options) {
  options = options || {};

  var defaultSelect = "all";
  if (options.defaultSelect) {
      defaultSelect = options.defaultSelect;
  }

  var $customDropdown = createDom($select, options);
  var selectionStream = $customDropdown.find('.select-item').asEventStream('click').map(c.$target);

  if (options.checkboxState) {
    var $checkbox = $customDropdown.find('input[type="checkbox"]');
    options.checkboxState.onValue(function (state) {
      if (state === states.UNCHECKED) {
        $checkbox.prop("checked", false).attr('data-indeterminate', 'false');
      } else if (state === states.CHECKED) {
        $checkbox.prop("checked", true).attr('data-indeterminate', 'false');
      } else if (state === states.INDETERMINATE) {
        $checkbox.prop("checked", true).attr('data-indeterminate', 'true');
      }
    });
    return selectionStream.map(getValue).merge($customDropdown.find('input[type="checkbox"]').asEventStream('change').map((event) => getCheckboxState(event, defaultSelect))).doAction(closeDropdown);
  }
  if (options.type === 'action') {
    return selectionStream.doAction(closeDropdown).map(getValue);
  }
  return selectionStream.doAction(function ($item) {
    $customDropdown.find('.selected').removeClass('selected');
    $item.addClass('selected');
    $customDropdown.find('option').removeAttr('selected');
    $customDropdown.find('option[value="' + $item.attr('data-value') + '"]').prop('selected', true);
    $customDropdown.find('.customDropdownSelect').text($item.text());
  }).doAction(closeDropdown).map(getValue);
}

export default {
  init: initSelect,
  states: states
};



// WEBPACK FOOTER //
// ./web/js/custom-select.js